/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Switch, Case, Default } from "react-if";
import { Button, theme } from "@nordcloud/gnui";
import { Sidebar } from "~/components";
import { useDisclosure } from "~/hooks";
import { useCloudAccount } from "../../../../CloudAccountProvider";
import { AwsForm } from "./AwsForm";
import { AzureForm } from "./AzureForm";
import { GoogleForm } from "./GoogleForm";
import { IbmForm } from "./IbmForm";

export function CredentialEditSidebar() {
  const { isOpen, open, close } = useDisclosure();
  const { cloudAccount } = useCloudAccount();

  return (
    <>
      <Button
        mr={theme.spacing.spacing04}
        severity="low"
        icon="edit"
        onClick={open}
      >
        Edit Credentials
      </Button>
      <Sidebar title="Edit Credentials" isOpen={isOpen} onClick={close}>
        <Switch>
          <Case condition={cloudAccount?.provider === "AWS"}>
            <AwsForm onSuccess={close} />
          </Case>
          <Case condition={cloudAccount?.provider === "AZURE"}>
            <AzureForm onSuccess={close} />
          </Case>
          <Case condition={cloudAccount?.provider === "GC"}>
            <GoogleForm onSuccess={close} />
          </Case>
          <Case condition={cloudAccount?.provider === "IBM"}>
            <IbmForm onSuccess={close} />
          </Case>
          <Default>Feature not available on this account type</Default>
        </Switch>
      </Sidebar>
    </>
  );
}
